import api from '@/lib/api';
import type {
  SupportTicketListItem,
  SupportTicketDetail,
  CreateTicketPayload,
} from '@/types/support';

function unwrap<T>(data: T | { data: T }): T {
  return (data as { data?: T }).data ?? (data as T);
}

export async function fetchMyTickets(): Promise<SupportTicketListItem[]> {
  const { data } = await api.get('/support/tickets');
  const body = unwrap<SupportTicketListItem[] | { items: SupportTicketListItem[] }>(data);
  return Array.isArray(body) ? body : body.items;
}

export async function fetchMyTicket(id: string): Promise<SupportTicketDetail> {
  const { data } = await api.get(`/support/tickets/${id}`);
  return unwrap<SupportTicketDetail>(data);
}

export async function createSupportTicket(
  payload: CreateTicketPayload,
): Promise<SupportTicketDetail> {
  const { data } = await api.post('/support/tickets', payload);
  return unwrap<SupportTicketDetail>(data);
}

export async function postMyTicketMessage(
  id: string,
  body: string,
  attachments?: Array<{ name: string; url: string }>,
): Promise<void> {
  await api.post(`/support/tickets/${id}/messages`, { body, attachments });
}
